import { render, staticRenderFns } from "./MedicineBatchStock.vue?vue&type=template&id=19610698&scoped=true"
import script from "./MedicineBatchStock.vue?vue&type=script&lang=js"
export * from "./MedicineBatchStock.vue?vue&type=script&lang=js"
import style0 from "./MedicineBatchStock.vue?vue&type=style&index=0&id=19610698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19610698",
  null
  
)

export default component.exports